import portLogo from "../../../assets/storymap/Port_of_Seattle_Logo.svg";
import caiLogo from "../../../assets/CAI Full Color.png";
import downArrow from '../../../assets/storymap/downArrow.svg';

export default function StorymapFooter() {
  return (
    <footer className="pl-8 mt-8 border-t border-gray-200 bg-white">
      <div className="mx-auto flex items-center justify-between gap-8 px-6 py-6 md:px-12 lg:px-48">
        {/* Back to top */}
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="inline-flex items-center gap-2 text-port-blue transition-opacity hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-port-blue hover:scale-105"
        >
          <img
            src={downArrow}
            alt=""
            className="h-6 w-6 rotate-180"
            aria-hidden="true"
          />
          <span className="text-sm font-semibold">Back to top</span>
        </button>

        {/* Logos */}
        <div className="flex items-end gap-8">
          <img src={portLogo} alt="Port of Seattle logo" className="h-10 w-auto md:h-12" />
          <img src={caiLogo} alt="Community Attributes logo" className="h-10 w-auto md:h-12" />
        </div>
      </div>
    </footer>
  );
}